export const MOIS = ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'];
export const MOIS_COURT = ['Jan','Fév','Mar','Avr','Mai','Jun','Jul','Aoû','Sep','Oct','Nov','Déc'];

export const STATUTS_ADHESION = ['Actif','Suspendu','Inactif','Radié'];

export const MODES_PAIEMENT = ['Prélèvement auto','Virement','Chèque','Espèces'];
export const JOURS_PRELEVEMENT = ['1','3','5','10','30'];
export const PERIODICITES = ['Mensuelle','Trimestrielle','Semestrielle','Annuelle'];
export const BUREAU_ROLES = [
  { key: 'sec_general',  label: 'Secrétaire général(e)',       pin: 'tresorier' },
  { key: 'sec_adjoint',  label: 'Secrétaire adjoint(e)',       pin: 'tresorier' },
  { key: 'tresorier',    label: 'Trésorier(ère)',               pin: 'tresorier' },
  { key: 'tres_adjoint', label: 'Trésorier(ère) adjoint(e)',   pin: 'tresorier' },
  { key: 'commission',   label: 'Commission de contrôle',      pin: 'tresorier' },
  { key: 'delegue',      label: 'Délégué(e) syndical(e)',      pin: 'delegue'   },
];

export const CONTRATS = ['CDI','CDD','Vacation','Intérim','Stage','Autre'];
export const MANDATS = ['CSE','DS','RSCSE','CSE-C','RS-CSE-C','DS-C','DRCPNE','COR','SDASSP','RP','CSSCT','CSSCT-C'];
export const CONVENTIONS = ['CCN 51','CCN 66','CCN EFS','CCN Croix Rouge','CCN FEHAP','CCN NEXEM','CCN UNIFED','Accord de Branche UCANSS','Autre'];

export const STATUS_CYCLE = ['non_pointe','paye','defaut_provision','arret_adhesion','autre_motif'];
export const STATUS_LABELS = {
  non_pointe: 'Non pointé',
  paye: 'Payé',
  defaut_provision: 'Défaut provision',
  arret_adhesion: 'Arrêt adhésion',
  autre_motif: 'Autre motif',
};
export const STATUS_BADGE_CLASS = {
  non_pointe: 'badge-non',
  paye: 'badge-paye',
  defaut_provision: 'badge-impaye',
  arret_adhesion: 'badge-arret',
  autre_motif: 'badge-autre',
};
export const STATUS_CELL_CLASS = {
  non_pointe: 'cell-non',
  paye: 'cell-paye',
  defaut_provision: 'cell-defaut',
  arret_adhesion: 'cell-arret',
  autre_motif: 'cell-autre',
};
export const STATUS_ABBREV = {
  non_pointe: '–',
  paye: '✓',
  defaut_provision: 'DP',
  arret_adhesion: 'AA',
  autre_motif: 'AM',
};

export const NEEDS_MOTIF = ['defaut_provision','arret_adhesion','autre_motif'];

export function nextStatus(current) {
  const idx = STATUS_CYCLE.indexOf(current);
  return STATUS_CYCLE[(idx + 1) % STATUS_CYCLE.length];
}

export function initials(prenom, nom) {
  return ((prenom?.[0] || '') + (nom?.[0] || '')).toUpperCase();
}

export function formatMontant(n) {
  return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(n || 0);
}

export function formatDate(str) {
  if (!str) return '—';
  const d = new Date(str);
  return d.toLocaleDateString('fr-FR');
}

export function anciennete(dateStr) {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  const now = new Date();
  const years = Math.floor((now - d) / (365.25 * 24 * 3600 * 1000));
  if (years < 1) {
    const months = Math.floor((now - d) / (30.5 * 24 * 3600 * 1000));
    return `${months} mois`;
  }
  return `${years} an${years > 1 ? 's' : ''}`;
}

export function montantAnnuel(adh) {
  const m = adh.montant || 0;
  switch (adh.periodicite) {
    case 'Mensuelle': return m * 12;
    case 'Trimestrielle': return m * 4;
    case 'Semestrielle': return m * 2;
    case 'Annuelle': return m;
    default: return m * 12;
  }
}

export const MOIS_TRIMESTRIEL = [2, 5, 8, 11]; // Feb / Mai / Aoû / Nov
export const MOIS_SEMESTRIEL  = [2, 8];         // Feb / Aoû

// Retourne les mois d'échéance réels d'un adhérent selon sa périodicité.
// yearCots : cotisations[selectedYear] — utilisé pour déduire le mois des adhérents Annuels
export function moisActifs(adh, yearCots = null) {
  switch (adh?.periodicite) {
    case 'Mensuelle':     return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    case 'Trimestrielle': return MOIS_TRIMESTRIEL;
    case 'Semestrielle':  return MOIS_SEMESTRIEL;
    case 'Annuelle': {
      // 1. Champ explicite dans la fiche adhérent
      if (adh.moisEcheanceAnnuelle) return [Number(adh.moisEcheanceAnnuelle)];
      // 2. Déduire depuis les cotisations (premier mois pointé sur l'année)
      if (yearCots && yearCots[adh.id]) {
        const pointedMonths = Object.keys(yearCots[adh.id]).map(Number).filter(n => n >= 1 && n <= 12);
        if (pointedMonths.length > 0) return [Math.min(...pointedMonths)];
      }
      // 3. Fallback janvier
      return [1];
    }
    default: return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]; // traité comme Mensuelle
  }
}

export function uid() {
  return 'id_' + Math.random().toString(36).slice(2,10) + '_' + Date.now().toString(36);
}

export function journalEntry(action, detail) {
  return {
    id: uid(),
    date: new Date().toISOString(),
    action,
    detail,
  };
}

export function exportCSV(rows, filename) {
  const csv = rows.map(r => r.map(cell => `"${String(cell ?? '').replace(/"/g,'""')}"`).join(';')).join('\n');
  const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
}

export function printElement(id) {
  const el = document.getElementById(id);
  if (!el) return;
  const w = window.open('', '_blank');
  w.document.write(`<html><head><title>Impression</title>
    <style>
      body{font-family:Arial,sans-serif;font-size:12px;color:#111;padding:20px}
      table{width:100%;border-collapse:collapse}
      th,td{border:1px solid #ddd;padding:6px 8px;text-align:left}
      th{background:#f0f0f0;font-weight:bold}
      .badge{display:inline-block;padding:1px 6px;border-radius:10px;font-size:11px}
      h1,h2,h3{color:#CC0000}
      @media print{button{display:none}}
    </style>
    </head><body>${el.innerHTML}
    <script>window.onload=function(){window.print();window.close()}<\/script>
    </body></html>`);
  w.document.close();
}
